module.exports = __webpack_public_path__ + "static/media/trident.94f62ba0.jpg";